import { createSlice } from "@reduxjs/toolkit";
import { getAllMedicines } from "../API/Medicines";
import { getMedicinePotency } from "../API/Medicines";

const initialState = {
    getallMedicines: [],
    loading: false,
    error: null,
};

const MedicinesSlice = createSlice({
  name: "Medicines",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllMedicines.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllMedicines.fulfilled, (state, action) => {
        state.loading = false;
        state.getallMedicines = Array.isArray(action.payload)
          ? action.payload
          : (Array.isArray(action.payload?.data) ? action.payload.data : []);
      })
      .addCase(getAllMedicines.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })

      .addCase(getMedicinePotency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMedicinePotency.fulfilled, (state, action) => {
        state.loading = false;
        state.getmedicinePotency = action.payload;
      })
      .addCase(getMedicinePotency.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })
  },
});

export default MedicinesSlice.reducer;